import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  title: string
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
}

export const DeleteInstructionDialog = ({ open, title, onConfirm, onOpenChange }: Props) => {
  const m = useMessages(messages)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-card dark:bg-[#1a1a1b] border-border dark:border-foreground/10 max-w-sm">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[15px] text-foreground dark:text-white">
            {m.deleteTitle}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[13px] text-muted-foreground dark:text-foreground/50">
            {m.deleteDescription(title)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="h-8 px-3 text-[13px] bg-transparent border-border text-muted-foreground hover:text-foreground hover:bg-muted dark:border-foreground/10 dark:text-foreground/60 dark:hover:text-white dark:hover:bg-foreground/5">
            {m.cancel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="h-8 px-3 text-[13px] bg-red-500/20 text-red-400 hover:bg-red-500/30 border-0"
          >
            {m.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
